















import mixins from 'vue-typed-mixins';
import SurveyForm from '@/components/survey/management/SurveyForm.vue';
import SurveyUtils, { Survey } from '../../utils/SurveyUtils';
export default mixins().extend({
  components: {
    SurveyForm,
  },
  data(): {
    survey: Survey;
  } {
    return {
      survey: {
        name: {
          admin: '',
          public: this.$languageobj(),
        },
        state: 'inactive',
        layout: [],
        surveygroup: {},
        options: {
          documents: {
            value: false,
            text: this.$languageobj('model.document.label', { choice: 2 }),
          },
        },
        filter: {
          providerTypes: [],
          oversights: [],
        },
        languageobjects: {
          organization: this.$languageobj('model.survey.organization'),
          suborg: this.$languageobj('model.survey.suborg'),
          pointofservice: this.$languageobj('model.survey.pointofservice'),
        },
        bookshelf: undefined,
        dashboard: {
          canvas: {
            left: [],
            right: [],
          },
        },
      },
    };
  },
  methods: {
    async submit() {
      try {
        this.$alert.hide('submit');

        await SurveyUtils.api.survey.add(this.survey);
        await this.$router.push({ name: 'survey-management' });

        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [this.survey.name.admin],
          }),
        });
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
  },
});
